<template>
  <!-- 固定资产盘点明细 -->
  <div class="IA_fixedAssetInventoryDetail"
       :style="{
      '--header_fontsize':
        (pageinfo.header_fontsize ? pageinfo.header_fontsize : 14) + 'px',
      '--header_isbold': pageinfo.header_isbold ? 'bold' : 'unset'
    }">
    <van-nav-bar :title="'盘点明细'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content"
         :class="has_feedback?'':'fullContent'">
      <div class="table_content">
        <ve-table :columns="thList"
                  border-y
                  :table-data="tableData"
                  :footer-data="totalData"
                  :scrollWidth="scrollWidth"
                  :style="
            tableData.length == 0
              ? 'height:100px;'
              : 'height: 100%;' + 'width:100%;word-break:break-word'
          "
                  max-height="100%"
                  :cell-span-option="cellSpanOption"
                  :cell-style-option="cellStyleOption" />
        <div v-show="tableData.length == 0"
             class="empty-data"
             style="font-size:16px;text-align: center">
          暂无数据
        </div>
      </div>
    </div>
    <div v-if="has_feedback"
         class="has_feedback">
      <div class="has_feedback_btn1"
           @click="inventory">
        {{ '盘点' }}
      </div>
      <div class="has_feedback_btn2"
           @click="complete">
        {{ '完结' }}
      </div>
    </div>
    <!-- 扫描二维码弹窗 -->
    <ScanQRCode ref="refScanQRCode"
                @getQRCodeContent="getQRCodeContent"></ScanQRCode>
  </div>
</template>

<script>
// 引入组件库
import { VeTable } from 'vue-easytable' // VePagination, VeIcon, VeLoading, VeLocale
import { Dialog, Toast, Notify } from 'vant'
import { GetJsSign } from '@api/hp.js'
import { getHrQueryPageInfoRawJson, getFixedAssetsPdDetail, getBeforePdCloseFixedAssetsInfo, pdCloseFixedAssets } from '@api/wx.js'
import ScanQRCode from "@components/scanQRCode/index.vue";
export default {
  components: {
    VeTable,
    ScanQRCode
  },
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const mautoid = this.$route.query.autoid
    return {
      userInfo,
      moduleno: 1337001,
      mautoid,
      scrollWidth: 0,
      thList: [], // 表头列表
      tableData: [], // 表格数据
      ini: [], // 原始表格数据
      ini2: [], // 原始最后一行合计数据
      totalData: [], // 最后一行合计数据
      valueData: [], // 记录
      pageinfo: {}, // 页面配置信息
      fieldlist: [], // 字段信息
      app_fix_col_count: 0, // 表格固定多少列
      appquery_jump_btn_title: '', // 查看明细按钮文字
      appquery_jump_detail: false, // 是否显示查看明细
      appquery_jump_fieldname: '', // 查看明细参数名
      appquery_jump_moduleno: '', // 查看明细跳转模块号
      show_err_action_btn: false, // 是否显示处理异常列
      err_action_btn_caption: '', // 异常按钮标题
      merge_cell_count: 0, // 表格自动合并前n列单元格
      isHasPD: false, // 是否已完结
    }
  },
  computed: {
    // 是否按钮
    has_feedback () {
      const activeName = this.$route.query.activeName
      if (activeName == 'c' || this.isHasPD)
      {
        return false
      } else
      {
        return true
      }
    },
    showAtfile () {
      let fieldnames = this.thList.map(it => {
        return it.fieldname
      })
      if (fieldnames.includes('atfileflag'))
      {
        return true
      } else
      {
        return false
      }
    },
    // 表格合并单元格
    cellSpanOption () {
      if (this.merge_cell_count > 0)
      {
        return {
          bodyCellSpan: this.mergeCells
        }
      } else
      {
        return {}
      }
    },
    // 需要合并的前n-1列的表头
    mergedLeftFieldlist () {
      let fileds = []
      this.fieldlist.forEach((el, i) => {
        if ((i + 1) <= this.merge_cell_count && el.gridwith)
        {
          fileds.push(el.fieldname)
        }
      });
      if (fileds.length > 0)
      {
        return fileds.slice(0, -1)
      } else
      {
        return []
      }
    },
    // 需要合并的最后一列的表头
    mergedRightFieldlist () {
      let fileds = []
      this.fieldlist.forEach((el, i) => {
        if ((i + 1) <= this.merge_cell_count && el.gridwith)
        {
          fileds.push(el.fieldname)
        }
      });
      return fileds
    },
    // 添加合并单元格样式
    cellStyleOption () {
      if (this.merge_cell_count > 0)
      {
        return {
          bodyCellClass: ({ row, column, rowIndex }) => {
            if (this.mergedRightFieldlist.includes(column.field))
            {
              return 'merged-cell';
            }
          }
        }
      } else
      {
        return {}
      }
    }
  },
  created () {
    this.mautoid = this.$route.query.autoid
    this.getFixedAssetsPdDetailData()
  },
  mounted () {

  },
  methods: {
    // 扫描二维码弹窗回调
    getQRCodeContent (result) {
      // console.log('getQRCodeContent', val);
      const oldUrl = 'http://hyclound.cn/weixin/queryrpt/zhongzhuan.html?hyrptparas=固定资产资料' // 旧版
      const newUrl = 'commHrQueryPage?moduleno=1320&fromH5=true&path=wxscan'
      if (result.indexOf(oldUrl) > -1 || result.indexOf(newUrl) > -1)
      {
        const url = new URL(result);
        // 使用searchParams属性来访问查询参数
        const params = url.searchParams;
        // 获取特定的参数
        let autoid = ''
        let moduleno = ''
        if (result.indexOf(oldUrl) > -1)
        {
          const hyrptparas = params.get('hyrptparas');
          moduleno = hyrptparas.split('|')[3]
          autoid = params.get('autoid');
        } else
        {
          moduleno = params.get('moduleno');
          autoid = params.get('param');
        }
        if (autoid)
        {
          const host = window.location.origin;
          const url = host + "/commHrQueryPage?moduleno=" + moduleno + '&param=' + autoid + '&fromH5=true&path=wxscan&showbtn=true&fromPage=fixedAssetInventoryDetail&mautoid=' + this.mautoid + '&activeName=' + this.$route.query.activeName
          // location.href = url + '&showbtn=true' + '&mautoid=' +**;
          location.replace(url)
        }
      } else
      {
        alert('cancel:' + '二维码地址不合法')
      }
    },
    // 盘点
    inventory () {
      this.$refs.refScanQRCode.showScanCode = true
    },
    // 完结
    complete () {
      getBeforePdCloseFixedAssetsInfo({
        mautoid: this.mautoid,
        username: this.userInfo.username
      }).then(res => {
        if (res.data[0] && res.data[0].info)
        {
          Dialog.confirm({
            title: this.$t('module.systemhint'),
            message: res.data[0].info
          }).then(() => {
            this.pdCloseFixedAssetsFun()
          }).catch(() => {
            // on cancel
          });
        } else
        {
          this.pdCloseFixedAssetsFun()
        }
      })
    },
    // 固定资产盘点完结操作处理接口
    pdCloseFixedAssetsFun () {
      pdCloseFixedAssets({
        mautoid: this.mautoid,
        username: this.userInfo.username
      }).then(res => {
        if (res.data[0] && res.data[0].info)
        {
          Toast.fail(res.data[0].info)
        } else
        {
          this.isHasPD = true
        }
        this.getFixedAssetsPdDetailData()
      })
    },
    // 查询固定资产盘点明细记录信息
    getFixedAssetsPdDetailData () {
      getFixedAssetsPdDetail({
        mautoid: this.mautoid,
        username: this.userInfo.username
      }).then(res => {
        this.valueData = res.data
        this.getHrQueryPageInfo(JSON.stringify(res))
      })
    },
    // 查询构造表格信息
    getHrQueryPageInfo (jsonstr) {
      const empcode = this.userInfo.empcode
      const langid = localStorage.getItem('langid')
      getHrQueryPageInfoRawJson({
        moduleno: this.moduleno,
        empcode: empcode,
        langid: langid,
        jsonstr
      }).then(res => {
        this.fieldlist = res.fieldlist
        // this.jumplist = res.jumplist
        this.pageinfo = res.pageinfo[0]
        this.app_fix_col_count = this.pageinfo.app_fix_col_count
        this.appquery_jump_btn_title = this.pageinfo.appquery_jump_btn_title
        this.appquery_jump_detail = this.pageinfo.appquery_jump_detail
        this.appquery_jump_fieldname = this.pageinfo.appquery_jump_fieldname
        this.appquery_jump_moduleno = this.pageinfo.appquery_jump_moduleno
        this.show_err_action_btn = this.pageinfo.show_err_action_btn // 是否显示处理异常列
        this.err_action_btn_caption = this.pageinfo.err_action_btn_caption // 按钮标题
        this.merge_cell_count = this.pageinfo.merge_cell_count
        // if (this.pageinfo.apptemplateid != 0)
        // {
        // 用表格显示
        this.thList = JSON.parse(JSON.stringify(this.fieldlist))
        this.thList = this.thList.filter(it => {
          return it.gridwith
        })
        // 是否显示处理异常列
        if (this.show_err_action_btn)
        {
          this.thList.unshift({
            type: 'btn',
            fieldname: '',
            chnname: '操作',
            gridwith: 40,
            footerkind: 'skNone',
            appgroupname: ''
          })
        }
        let obj = {
          fieldname: 'serial',
          chnname: '序号',
          gridwith: this.pageinfo.sqnum_width || 25,
          footerkind: 'skNone',
          appgroupname: ''
        }
        if (this.pageinfo.sqnum_width != 0)
        {
          this.thList.unshift(obj)
        }
        // 固定多少列
        let frozenColCount = this.app_fix_col_count ? parseInt(this.app_fix_col_count + 1) : 1 // 因为手工添加了一列“序号”所以要加1
        // 如果有操作列，再加1
        if (this.show_err_action_btn)
        {
          frozenColCount = frozenColCount + 1
        }
        this.scrollWidth = 0
        this.thList.forEach((it, ii) => {
          if (ii < frozenColCount)
          {
            it.fixed = 'left'
            this.scrollWidth += it.gridwith * 2
          }
          it.title = it.chnname ? it.chnname.replace(/<br>/g, "\n") : it.chnname
          it.field = it.fieldname

          it.key = 'k' + ii
          it.width = it.gridwith * 2 //先注释掉用自适应显示
          const fieldvalue_align = it.fieldvalue_align || 'center'
          it.align = fieldvalue_align
          // 自定义单元格--此页面中ispd的需要高亮
          if (it.fieldname == 'atfileflag')
          {
            // 附件
            it.renderBodyCell = ({ row, column, rowIndex }, h) => {
              const url = require('@assets/img/ft_ico_fj.png')
              const bgcolor = row.v8_rgb_color_field ? row.v8_rgb_color_field : row.ispd ? '#07c160' : '#ffffff'
              const fontColor = row.v8_rgb_font_color ? row.v8_rgb_font_color : row.ispd ? '#ffffff' : '#000000d9'
              const style =
                'height: 100%; display: flex; align-items: center;width: 100%;padding:10px; background:' +
                bgcolor +
                ';color:' +
                fontColor +
                ';'
              if (this.showAtfile && row.atfileflag == 1)
              {
                return (
                  <div
                    style={style}
                    on-click={() => {
                      // console.log(row, 'rowrow');
                      if (row.module_file_url)
                      {
                        window.open(row.module_file_url)
                      }
                    }}
                  >
                    <img src={url} alt="" style="width:19px;height:18px;" />
                  </div>
                )
              } else
              {
                return <div style={style}></div>
              }
            }
          } else if (it.fielddatatype == 'bit')
          {
            // 布尔类型
            it.renderBodyCell = ({ row, column, rowIndex }, h) => {
              const text = row[column.field]
              const bgcolor = row.v8_rgb_color_field ? row.v8_rgb_color_field : row.ispd ? '#07c160' : '#ffffff'
              const fontColor = row.v8_rgb_font_color ? row.v8_rgb_font_color : row.ispd ? '#ffffff' : '#000000d9'
              const style =
                'height: 100%; display: flex; align-items: center;justify-content: center;width: 100%;padding:10px; background:' +
                bgcolor +
                ';color:' +
                fontColor +
                ';'
              const url = text
                ? require('@assets/img/comm_qy_checked.png')
                : require('@assets/img/comm_qy_uncheck.png')

              if (
                window.CloundEntid == '236' &&
                data.moduleno == '1228' &&
                it.fieldname == 'release' &&
                !text
              )
              {
                /// 联升 访客记录特殊修改
                return (
                  <div style={style}>
                    <van-button
                      type="info"
                      size="small"
                      on-click={() => this.b4lianShengFX(row)}
                    >
                      确认放行
                    </van-button>
                  </div>
                )
              } else
              {
                return (
                  <div style={style}>
                    <img src={url} alt="" style="width:20px;height:20px;" />
                  </div>
                )
              }
            }
          } else
          {
            // 文本
            it.renderBodyCell = ({ row, column, rowIndex }, h) => {
              const text = row[column.field]
              const bgcolor = row.v8_rgb_color_field ? row.v8_rgb_color_field : row.ispd ? '#07c160' : '#ffffff'
              const fontColor = row.v8_rgb_font_color ? row.v8_rgb_font_color : row.ispd ? '#ffffff' : '#000000d9'
              const style =
                'height: 100%;  align-items: center;width: 100%;padding:10px; font-size:' +
                this.pageinfo.fontsize +
                'px;text-align:' +
                fieldvalue_align +
                '; background:' +
                bgcolor +
                ';color:' +
                fontColor +
                ';'
              return <div style={style}>{text}</div>
            }
          }
          // 是否显示处理异常列
          if (it.type == 'btn')
          {
            it.renderBodyCell = ({ row, column, rowIndex }, h) => {
              const show_err_action_btn = row.show_err_action_btn
              const bgcolor = row.v8_rgb_color_field ? row.v8_rgb_color_field : row.ispd ? '#07c160' : '#ffffff'
              const fontColor = row.v8_rgb_font_color ? row.v8_rgb_font_color : row.ispd ? '#ffffff' : '#000000d9'
              const style =
                'height: 100%;  align-items: center;width: 100%;padding:10px; font-size: 14px;text-align:' +
                fieldvalue_align +
                '; background:' +
                bgcolor +
                ';color:' +
                fontColor +
                ';' +
                ' display: flex; align-items: center; justify-content: center;'
              if (show_err_action_btn)
              {
                return (
                  <div style={style}>
                    <van-button
                      type="info"
                      size="small"
                      on-click={() => this.checkUrlToGo(row)}
                    >
                      {this.err_action_btn_caption}
                    </van-button>
                  </div>
                )
              } else
              {
                return <div style={style}> </div>
              }
            }
          }
        })
        // console.log(this.scrollWidth, 'scrollWidthscrollWidthscrollWidth');
        // console.log(this.thList, 'this.thList');
        this.tableData = JSON.parse(JSON.stringify(this.valueData))
        // 改造数据结构
        this.tableData.forEach((it, idx) => {
          it.serial = idx + 1
        })

        // 如果表格启用汇总
        if (this.pageinfo.openfooter)
        {
          this.totalData = [{ serial: '汇总' }]
          this.thList.forEach(it => {
            if (it.fieldname != 'serial')
            {
              if (it.gridwith && it.footerkind != 'skNone')
              {
                let result = ''
                const values = this.tableData.map(item =>
                  parseFloat(item[it.fieldname])
                )
                if (!values.every(value => isNaN(value)))
                {
                  switch (it.footerkind)
                  {
                    case 'skAverage':
                      result = this.computedAverage(values)
                      break
                    case 'skCount':
                      result = this.computedCount(values)
                      break
                    case 'skMax':
                      result = this.computedMax(values)
                      break
                    case 'skMin':
                      result = this.computedMin(values)
                      break
                    case 'skSum':
                      let tol = this.computedSum(values)
                      result = Math.round(tol * 100) / 100
                      break
                  }
                  result = String(result)
                  const dot = result.indexOf('.')
                  if (dot > -1)
                  {
                    result = result.slice(0, dot + 3)
                  }
                }
                // this.totalData.push(result)
                this.totalData[0][it.fieldname] = result
              } else
              {
                if (it.gridwith && it.gridwith != 0)
                {
                  // this.totalData.push('')
                  this.totalData[0][it.fieldname] = ''
                }
              }
            }
          })
          // console.log(this.totalData, 'this.totalData');
        }
        this.ini = JSON.parse(JSON.stringify(this.tableData))
        this.ini2 = JSON.parse(JSON.stringify(this.totalData))
        // }
      })
    },
    checkUrlToGo (row) { },
    b4lianShengFX (row) { },
    // 表格body合并单元格
    mergeCells ({ row, column, rowIndex }) {
      // 只处理前n-1列的合并
      if (this.mergedLeftFieldlist.includes(column.field))
      {
        const prevRow = this.tableData[rowIndex - 1]
        let nextRow = this.tableData[rowIndex + 1]
        let currentKey = this.getMergeKey(this.mergedLeftFieldlist, row)
        // 判断是否为新组合的起始行
        if (!prevRow || this.getMergeKey(this.mergedLeftFieldlist, prevRow) !== currentKey)
        {
          let rowspan = 1
          // 计算相同组合的行数
          while (nextRow && this.getMergeKey(this.mergedLeftFieldlist, nextRow) === currentKey)
          {
            rowspan++
            nextRow = this.tableData[rowIndex + rowspan]
          }
          return { rowspan, colspan: 1 }
        }
        return { rowspan: 0, colspan: 0 }
      } else if ([this.mergedRightFieldlist[this.mergedRightFieldlist.length - 1]].includes(column.field))
      {
        // 处理最后一列的合并
        const currentKey = this.getMergeKey(this.mergedRightFieldlist, row)
        const prevRow = this.tableData[rowIndex - 1]
        let nextRow = this.tableData[rowIndex + 1]
        // 判断是否为新组合的起始行
        if (!prevRow || this.getMergeKey(this.mergedRightFieldlist, prevRow) !== currentKey)
        {
          let rowspan = 1
          // 计算相同组合的行数
          while (nextRow && this.getMergeKey(this.mergedRightFieldlist, nextRow) === currentKey)
          {
            rowspan++
            nextRow = this.tableData[rowIndex + rowspan]
          }
          return { rowspan, colspan: 1 }
        }
        return { rowspan: 0, colspan: 0 }
      }
    },
    // 根据字段名数组获取合并单元格组合值
    getMergeKey (fieldList, row) {
      let Key = ''
      fieldList.forEach((fl, i) => {
        if (row)
        {
          Key += row[fl]
        }
        if (i < fieldList.length - 1)
        { // 除了最后一个元素外，都加上'-' 
          if (Key)
          {
            Key += '-'
          }
        }
      });
      return Key
    },
    // 平均值
    computedAverage (arr) {
      return Math.floor((sum(arr) * 1000) / arr.length) / 1000
    },
    // 整数
    computedCount (arr) {
      return arr.length
    },
    // 最大值
    computedMax (arr) {
      return Math.max(...arr)
    },
    // 最小值
    computedMin (arr) {
      return Math.min(...arr)
    },
    // 求和
    computedSum (arr) {
      return arr.reduce((prev, curr) => {
        const value = Number(curr)
        if (!isNaN(value))
        {
          return prev + curr
        } else
        {
          return prev
        }
      }, 0)
    },
    // 返回
    onClickLeft () {
      // 固定资产盘点
      this.$router.push({
        path: '/fixedAssetInventory',
        query: { from: 'personCen', activeName: this.$route.query.activeName }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.IA_fixedAssetInventoryDetail {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .fullContent {
    height: calc(100% - 92px) !important;
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px - 132px);
    .table_content {
      height: 100%;
      .vue-table-root {
        /deep/.ve-table {
          height: 100%;
          .ve-table-container {
            .ve-table-content-wrapper {
              .ve-table-content {
                .ve-table-header {
                  .ve-table-header-tr {
                    height: 80px;
                    .ve-table-header-th {
                      font-size: var(--header_fontsize); // 28px;
                      font-weight: var(--header_isbold); // bold;
                      white-space: pre-wrap;
                    }
                  }
                }
                .ve-table-body {
                  .ve-table-body-tr {
                    .ve-table-body-td {
                      padding: 0 !important;
                    }
                    .merged-cell {
                      div {
                        display: flex;
                        justify-content: center;
                      }
                    }
                  }
                }
                .ve-table-footer {
                  .ve-table-footer-tr {
                    height: 80px;

                    .ve-table-footer-td {
                      font-size: 28px;
                      background-color: rgb(255, 211, 184);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .auto_table {
        height: 100%;
        overflow: auto;
        .table {
          width: 100%;
          border-spacing: 0px;
          tr {
            td:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
            th,
            td {
              padding: 6px 10px;
              text-align: center;
              border-bottom: 2px solid #dcdfe6;
              border-right: 2px solid #dcdfe6;
              .comm_box {
                .boolean_box {
                  .van-checkbox {
                    justify-content: center;
                    /deep/.van-checkbox__icon--checked {
                      .van-icon {
                        color: #fff !important;
                        background-color: #1989fa !important;
                        border-color: #1989fa !important;
                      }
                    }
                    /deep/.van-checkbox__icon--disabled .van-icon {
                      background-color: #fff;
                    }
                  }
                }
              }
            }
          }
          .top {
            position: sticky;
            top: 0;
            font-size: 28px;
            background: #e9f3fd;
            height: 64px;
            th:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
          }
          .cont {
            height: 64px;
            font-size: 24px;
          }
          .cont:nth-child(2n-1) {
            background: #f5f5f5;
          }
        }
      }
    }
  }
  .has_feedback {
    position: relative;
    // z-index: 9999;
    height: 132px;
    width: 100%;
    padding: 0 20px;
    background: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    .onlyOneBtn {
      width: 90% !important;
    }
    .has_feedback_btn1,
    .has_feedback_btn2 {
      height: 90px;
      text-align: center;
      line-height: 90px;
      color: #fff;
      font-size: 32px;
      border-radius: 12px;
      flex: auto;
    }
    .has_feedback_btn1 {
      // width: 40%;
      // width: 30%;
      // background: rgb(255, 174, 201);
      background: #07c160;
    }
    .has_feedback_btn2 {
      // width: 40%;
      // width: 30%;
      background: #2b8df0;
    }
  }
}
</style>